@let accentColor =
  config().accentColorBySubType?.[subType()] ?? config().accentColor;

<div class="selection">
  <div class="offer">
    <p
      class="catch-phrase"
      [style]="{
        color: accentColor,
        fontFamily: config().catchPhrase.fontFamily,
      }"
    >
      <span class="first-line">{{ config().catchPhrase.firstLine }}</span>
      <span class="second-line">{{ config().catchPhrase.secondLine }}</span>
    </p>

    <b2c-reward-sticker
      class="max-reward"
      [amount]="maxReward()"
      [imageUrl]="config().maxReward.backgroundImage.imageUrl"
      [amountColor]="config().maxReward.amountColor"
      [amountFontFamily]="config().maxReward.amountFontFamily"
      [alternativeText]="
        config().maxReward.backgroundImage.alternativeText
          | replaceVars: maxReward()
      "
    />
  </div>

  <b2c-button
    cssClass="select-btn"
    data-cy="select_btn"
    [styles]="{
      color: config().button.color,
      backgroundColor: accentColor,
      fontFamily: config().button.fontFamily,
    }"
    [loadingBorderColor]="config().button.color"
    [title]="config().button.title"
    [loading]="selectionInProgress()"
    (click)="
      selectChallenge(challenge(), phase(), isBisCampaign(), isEventChallenge())
    "
    [disabled]="
      challenge().isOutOfStock() ||
      selectionInProgress() ||
      blockSelectionButton()
    "
  >
    {{ config().button.label }}
    <img class="arrow" alt="" [src]="config().button.iconUrl" />
  </b2c-button>
</div>
